/**
 * Wyglad przycisku akcji jako biala karta z ramka — ikona po lewej, etykieta
 * capsem, pelna szerokosc kontenera. Uzywany w naglowkach podstron na mobile,
 * gdzie pojedynczy przycisk tekstowy gubil sie na tle.
 *
 * Byl wpisany osobno w kazdym miejscu wywolania, wiec ekrany zaczely sie
 * rozjezdzac. Trzymamy go w jednym miejscu i rozwijamy w `sx`.
 */
export const cardActionButtonSx = {
  justifyContent: 'flex-start',
  minWidth: 0,
  width: '100%',
  border: '1px solid var(--color-border)',
  backgroundColor: 'var(--color-surface)',
  px: 'var(--space-4)',
};

/**
 * Stopka dialogu z akcjami. Na telefonie przyciski ida w kolumne na cala
 * szerokosc, `column-reverse` — kolejnosc w DOM to (anuluj, ..., zapisz), wiec
 * odwrocenie stawia akcje glowna na gorze, zgodnie z konwencja mobilna.
 *
 * W rzedzie trzy przyciski nie mieszczily sie na waskim ekranie i etykieta
 * "Zapisz zmiany" lamala sie na dwie linie.
 */
export const dialogActionsSx = {
  display: 'flex',
  flexDirection: { xs: 'column-reverse', sm: 'row' },
  justifyContent: 'flex-end',
  alignItems: 'stretch',
  gap: 'var(--space-2)',
  mt: 'var(--space-6)',
};

export const dialogButtonSx = {
  minHeight: 40,
  px: 'var(--space-4)',
  whiteSpace: 'nowrap',
};
